let lista = []
const requireComponentIcons = require.context(
  '@fortawesome/free-solid-svg-icons', true, /\.js$/
)
export const listIcons = () => {
  lista = []
  requireComponentIcons.keys().forEach(fileName => {
    if (fileName !== './index.js' && fileName !== './index.es.js' ) {
      let iconItem = {
        name: 'fas ' + fileName.replace('./', '').replace('.js', '').replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase(),
        id: lista.length
      }
      lista.push(iconItem)
    }
  })
  return lista
}